import { Box, Divider, InputAdornment, List, ListItem, Popover, Tab, Tabs, TextField } from "@mui/material"
import React, { useEffect, useState } from "react"
import EmojiPicker from 'emoji-picker-react';
import Search from "../assets/images/icon/Search";
import palette from "../theme/palette";
import * as icons from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { baseEndpoints } from "../services/config";

interface TabPanelProps {
    children?: React.ReactNode;
    index: string;
    value: string;
}

export const ICON_SLECTIN_TABS = {
    EMOJI: "EMOJI",
    ICON: "ICON",
    IMAGE: "IMAGE",
    BLANK: "BLANK",
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    <Box>{children}</Box>
                </Box>
            )}
        </div>
    );
}

const IconSelectionPopover = ({
    open = false,
    anchorEl,
    handleClose,
    icon = null,
    selectedTab = ICON_SLECTIN_TABS.EMOJI,
    onSelectIcon = (value: {
        selectedTab: string,
        selectedIcon: any
    }) => { }
}) => {
    const [selectedTabInner, setSelectedTabInner] = useState(selectedTab)
    const [searchText, setSearchText] = useState(null);
    const [hasCustom, setHasCustom] = useState(false);
    const [iconPack, setIconPack] = useState([]);
    useEffect(() => {
        const copyIcon = [];
        Object.keys(icons).map((icon) => {
            copyIcon.push(icons[icon]);
            return icon;
        });
        setIconPack(copyIcon);

        return () => setIconPack([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (selectedTab === ICON_SLECTIN_TABS.IMAGE) {
            setHasCustom(true)
        }
        if (selectedTab === ICON_SLECTIN_TABS.BLANK) {
            setSelectedTabInner(ICON_SLECTIN_TABS.EMOJI)
        }
        return () => setHasCustom(false)
    }, [selectedTab])
    const iconsFiltered = iconPack.filter((icon) => {
        if (searchText && icon && icon.iconName) {
            return (
                icon.iconName.includes(searchText.toLowerCase()) &&
                !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(
                    icon.iconName
                )
            );
        }
        return !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(
            icon.iconName
        );
    });

    const onSelectIconInner = (icon) => {
        onSelectIcon({
            selectedIcon: icon,
            selectedTab: selectedTabInner
        })
    }

    return <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        sx={{
            '& .MuiPaper-root': {
                background: "#FFFFFF",
                boxShadow: "0px 0px 64px 0px #190D1A1A",
                borderRadius: "12px",
                marginTop: "10px",
                maxWidth: "400px",
            }
        }}
    >
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
            }}
        >
            <Tabs
                value={selectedTabInner}
                onChange={(e, newTab) => {
                    setSelectedTabInner(newTab);
                }}
                sx={{
                    "& .MuiTabs-indicator": {
                        backgroundColor: "var(--color-new-main)"
                    },
                    "& .MuiButtonBase-root": {
                        padding: "0px 12px",
                        minHeight: "32px",
                        color: "var(--color-text-secondary) !important",
                        fontSize: "14px !important",
                        "&.Mui-selected": {
                            color: "var(--color-text-primary) !important",
                        }
                    },
                    minHeight: "36px"
                }}
                aria-label="basic tabs example"
            >
                <Tab label="Emoji" value={ICON_SLECTIN_TABS.EMOJI} className="tabLabel" />
                <Tab label="Icon" value={ICON_SLECTIN_TABS.ICON} className="tabLabel" />
                {hasCustom && <Tab label="Custom" value={ICON_SLECTIN_TABS.IMAGE} className="tabLabel" />}
            </Tabs>
            <TabPanel index={ICON_SLECTIN_TABS.EMOJI} value={selectedTabInner}>
                <EmojiPicker onEmojiClick={(emoji) => {
                    onSelectIconInner(emoji.emoji)
                }} />
            </TabPanel>
            <TabPanel index={ICON_SLECTIN_TABS.ICON} value={selectedTabInner}>
                <Box padding={"15px 10px"} borderTop={"1px solid var(--color-border)"} borderRadius={"12px 12px 0px 0px"}>
                    <div
                        className="iconPicker__popoverHeader"
                        style={{
                            width: "100%",
                        }}
                    >
                        <TextField
                            fullWidth
                            placeholder="Search"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                border: `1px solid ${palette.primary.main}`,
                                borderRadius: "12px",
                                "& .MuiInputBase-root": {
                                    borderRadius: "12px !important",
                                    padding: "0px !important",
                                    "& .MuiOutlinedInput-input": {
                                        padding: "12px 16px !important",
                                    }
                                },
                            }}
                            size="small"
                            variant="outlined"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                    <Divider />
                    <List
                        sx={{
                            pt: 1,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            gap: "12px",
                            flexWrap: "wrap",
                            width: "100%",
                        }}
                    >
                        {iconsFiltered.length > 0 &&
                            iconsFiltered?.map((icon, index: number) => {
                                return (
                                    icon.icon &&
                                    icon.icon.length > 0 && (
                                        <ListItem
                                            button
                                            sx={{
                                                display: "flex",
                                                padding: "10px 0",
                                                alignItems: "center",
                                                gap: "0",
                                                justifyContent: "center",
                                                borderRadius: "12px",
                                                border:
                                                /* icon.icon[icon.icon.length - 1] === selectedIcon
                                                    ? "1px solid #11734A"
                                                    :  */`1px solid #F3F3F3`,
                                                background: "#FFF",
                                                flexBasis: "22%",
                                            }}
                                            onClick={() => onSelectIconInner(icon.iconName)}
                                            key={index}
                                        >
                                            <div
                                                style={{
                                                    borderRadius: "12px",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    height: 20,
                                                    width: 20,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <FontAwesomeIcon size="2xs" icon={icon} />
                                            </div>
                                        </ListItem>
                                    )
                                );
                            })}
                    </List>
                </Box>

            </TabPanel>
            {hasCustom && <TabPanel index={ICON_SLECTIN_TABS.IMAGE} value={selectedTabInner}>
                <Box padding={"15px 10px"}  borderRadius={"12px 12px 0px 0px"}>
                    <Box display={"flex"} alignItems={"center"} justifyContent={"flex-start"} width={"100%"}>
                        <img
                            alt="toggl"
                            width="26px" height="26px"
                            src={
                                icon && `${baseEndpoints.getImage}${icon}`
                            }
                            style={{
                                height: "26px",
                                width: "26px",
                                borderRadius: "10px"
                            }}
                        />
                    </Box>

                </Box>

            </TabPanel>}
        </Box>
    </Popover>
}

export default IconSelectionPopover

export const FontAwesomeIconRender = ({
    selectedIcon,
    ...restProps
}) => {
    const [iconPack, setIconPack] = useState([]);
    useEffect(() => {
        const copyIcon = [];
        Object.keys(icons).map((icon) => {
            copyIcon.push(icons[icon]);
            return icon;
        });
        setIconPack(copyIcon);

        return () => setIconPack([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const iconsFiltered = iconPack.filter((icon) => {
        return !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(
            icon.iconName
        );
    });
    let copyProps = {}
    if (restProps) {
        copyProps = restProps
    }
    let foundIcon = null;
    if (selectedIcon.length < 50) {
        const found = iconsFiltered.find((it) => it.iconName === selectedIcon);
        if (found) {
            foundIcon = found;
        }
    }
    return foundIcon && (
        <FontAwesomeIcon size="2xs" icon={foundIcon} {...copyProps} />
    )
}

export const foundSelectedIcon = (selectedIcon) => {
    let foundIcon = null
    const copyIcon = [];
    Object.keys(icons).map((icon) => {
        copyIcon.push(icons[icon]);
        return icon;
    });
    const iconsFiltered = copyIcon.filter((icon) => {
        return !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(
            icon.iconName
        );
    });
    if (selectedIcon && selectedIcon.length < 50) {
        const found = iconsFiltered.find((it) => it.iconName === selectedIcon);
        if (found) {
            foundIcon = found;
        }
    }
    return foundIcon
}